(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClientsPotential',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);

		$('.potential-radios').change(function potentalClientRadioChanged() {
			if ($(this).prop('checked') === true) {
				clientSelected($(this).val());
			}
		});

		$('.potential-search-toggle').click(function toggleExisting() {
			$('.client-difference').addClass('hidden');
			$('.client-difference-checkbox').addClass('hidden');
			$('#client-changes-alert').addClass('hidden');
			$('#number-of-changes').text('');

			$('.potential-client-search').val('');

			if ($(this).prop('checked') === true) {
				$('.potential-radios').each(function clearRadios() {
					$(this).prop('checked', false);
				});

				$('.existing-search').removeClass('hidden');
				$('.existing-list').addClass('hidden');
			} else {
				$('#clientspotential-client_id').val('');

				$('.existing-search').addClass('hidden');
				$('.existing-list').removeClass('hidden');
			}
		});

	});

	form.load = function load()
	{
		Adzuki.Typeahead(
			'.potential-client-search',
			'/Clients/search',
			function select(item) {
				$('#clientspotential-client_id').val(item.id);
				clientSelected(item.id);
			},
			function template(item) {
				var html;

				if (item.result_name) {
					html = item.result_name;
				} else {
					html = item.full_name;
				}

				html += item.age;

				return html;
			}
		);

		if ($('#clientspotential-match').val() === 'false') {
			$('.potential-search-toggle').trigger("click");
			$('.existing-search').removeClass('hidden');
		}
	};

	function clientSelected(client_id) {
		var potential_client_id = $('#clientspotential-id').val();

		$('.client-difference').addClass('hidden');
		$('.client-difference-checkbox').addClass('hidden');

		Adzuki.Ajax.get('/ClientsPotential/comparePotentialToExisting/' + potential_client_id + '/' + client_id).then(
			function showCompareToExistingResult(response) {
				var num_changes = 0;

				if (response.length) {
					response.forEach(function showFieldWarning(fieldInfo) {
						var elemId     = 'client-' + fieldInfo.fieldName.replace(/_/g, '-'),
						    checkboxId = 'client-' + fieldInfo.fieldName.replace(/_/g, '-') + '-checkbox';

						if ($('#' + elemId).length) {
							num_changes++;
							$('#' + elemId).attr('title', "Changing from " + fieldInfo.oldValue + " to " + fieldInfo.newValue);
							$('#' + elemId).removeClass('hidden');
							$('#' + checkboxId).removeClass('hidden');
						} else {
							console.log(elemId + ' does not exist on page');
						}
					});

					if (num_changes > 1) {
						num_changes = num_changes + ' fields have';
					} else {
						num_changes = num_changes + ' field has';
					}

					$('#number-of-changes').text(num_changes);
					$('#client-changes-alert').removeClass('hidden');
				} else {
					$('#client-changes-alert').addClass('hidden');
					$('#number-of-changes').text('');
				}
			}
		);
	}

}(jQuery, window.Adzuki || {}));
